import React, { useSelector } from 'react-redux';
import { compose } from 'redux';
import withBoostrapApp from '../../components/HOC/withBoostrapApp';
import withSidebar from '../../components/HOC/withSidebar';
import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import Svg from '../../assets/svg';
import PasscodeInput from '../../components/inputs/PasscodeInput';
import { DASHBOARD } from '../../router/routeNames';
import FirestoreProtectedViews from '../../api/firebase/firebase.protectedViews';
const ProtectedViewsLock = () => {
  const navigate = useNavigate();
  const params = useParams();
  const user = useSelector((state) => state.user);
  const [passcode, setPasscode] = useState(['', '', '', '']);
  const [error, setError] = useState('');
  const isPasscodeComplete = passcode.every((digit) => digit !== '');

  const handleValueChange = (value) => {
    setPasscode(value);
    setError('');
  };
  const handleLockPage = async () => {
    const userId = user?.data?.uid;
    const code = passcode.join('');

    const protectedData = {
      name: params.route,
      page: {
        url: params.route,
        isLocked: true,
      },
      code: code,
      userId,
    };

    await FirestoreProtectedViews.CreatedOrUpdateProtectedView(protectedData);
    navigate(DASHBOARD, { replace: true });
  };

  return (
    <div>
      <div className="md:flex md:items-center md:justify-between">
        <div className="flex-1 min-w-0">
          <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate mb-4">
            Lock - {params.route?.toUpperCase()} access
          </h2>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center bg-white px-4 sm:px-6 lg:px-8 rounded-lg">
        <img src={Svg.protected_stars} alt="Lock" className="mx-auto" />
        <h2 className="text-lg text-gray-900 text-[24px] sm:text-[28px] font-semibold text-center mb-[23px]">
          Enter 4-digit Passcode
        </h2>
        <div className="mb-[25px]">
          <PasscodeInput
            passcode={passcode}
            onChangeText={handleValueChange}
            handleKeyDownChange={(value) => setPasscode(value)}
          />
        </div>
        {error && (
          <p className="text-red-500 text-center w-full max-w-xs">{error}</p>
        )}
        <div
          onClick={isPasscodeComplete ? handleLockPage : null}
          className={`w-full max-w-xs h-[60px] mt-4 p-2.5 rounded-xl 
            flex justify-center items-center 
            border transition-all duration-300 ease-in-out
            mb-8
        ${
          isPasscodeComplete
            ? 'bg-[#4343d6] border-[#4343d6] cursor-pointer hover:bg-[#3333b3]'
            : 'bg-gray-200 border-gray-400 cursor-not-allowed mb-8'
        }`}
        >
          <span
            className={`text-lg font-bold tracking-tight ${
              isPasscodeComplete ? 'text-white' : 'text-black'
            }`}
          >
            Lock - {params.route?.toUpperCase()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default compose(withBoostrapApp, withSidebar)(ProtectedViewsLock);
